export enum SnackbarMessageType {
  Info = 'Info',
  Error = 'Error',
}

export interface SnackbarMessage {
  text: string,
  type: SnackbarMessageType
}
